<template lang="pug">
  div.counts
    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null" data-test="candidates-count").counts__item.green--text {{ item.candidatesCount }}
          template(v-if="!hideMaxStudent")
            span /
            template(v-if="typeof item.maxStudents === 'number'")
              max-students(
                :maxStudents="item.maxStudents"
                :ID="item.ID"
                @updated="$emit('updated', $event)"
              )
            template(v-else) -
      span Candidates

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null").counts__item.counts__item_queue 
          template(v-if="!isCursussenPage") {{ item.topCbrReserveQueueCount }}|{{ item.topCbrExchangeQueueCount }}
          template(v-else) -
      span Top CBR

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null").counts__item.counts__item_mijn
          template(v-if="typeof item.mijnCbrQueueCount === 'number'") {{ item.mijnCbrQueueCount }}
          template(v-else) -
      span Mijn CBR

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null").counts__item.counts__item_slots {{ item.slotsCount }}
      span Slots
</template>

<script>
export default {
  props: {
    item: {
      Object,
      required: true,
    },
    hideMaxStudent: {
      type: Boolean,
      default: false,
    },
    withTooltip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCursussenPage() {
      return this.$route.name === this.$ROUTER_NAMES.CURSSUSEN
    }
  },
  components: {
    maxStudents: () => import('./cm_course/CMMaxStudents.vue')
  }
}
</script>

<style lang="scss" scoped>
  .counts {
    display: flex;
    align-items: center;
    border-top: 1px solid $border-color;
    &__item {
      padding: 4px 0;
      width: 25%;
      text-align: center;
      color: $label-color;
      border-right: 1px solid $border-color;
      &:last-child {
        border-right: unset;
      }
      &_queue {
        color: #79880E;
      }
      &_mijn {
        color: #3c16e9;
      }
      &_slots {
        border: 1px solid $warning-color;
        color: $warning-color;
      }
    }
  }
</style>
